export enum RequestRateType {
  New = 'new',
  Modify = 'modify',
}
